<template>
  <TableLayout :permissions="['business:actionLog:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>

      <el-form-item label="操作时间">
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="selectDate"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="操作人" prop="creatorName">
        <el-input v-model="searchForm.creatorName" placeholder="请输入操作人" v-trim/>
        <!-- <el-select v-model="searchForm.creator" placeholder="请选择">
          <el-option label="未归还" :value="1">
          </el-option>
          <el-option label="已归还" :value="1">
          </el-option>
        </el-select> -->
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:actionLog:exportExcel']">
        <li>
          <el-button type="primary" :loading="isWorking.export" v-permissions="['business:actionLog:exportExcel']"
            @click="exportExcel">导出</el-button>
        </li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe border>
        <el-table-column prop="openid" label="用户" min-width="140px" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            <div class="long-title-style">{{ row.openid }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="objId" label="系统单号" min-width="140px" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            <div class="long-title-style">{{ row.objId }}</div>
          </template>
        </el-table-column>
        <!-- payOnlineOrderid  支付押金交易单号 -->
        <!-- onlineOrderid 在线交易单号 -->
        <!-- preOrderid 交易预订单号 -->
        <el-table-column prop="onlineOrderid" label="交易单号" min-width="140px" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            <div class="long-title-style">{{ row.onlineOrderid }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="canBalance" label="当前可退回押金(元)" min-width="140px" align="center">
          
        </el-table-column>
        <el-table-column prop="money" label="退回押金(元)" min-width="140px" align="center">
        </el-table-column>
        <el-table-column prop="createDate" label="操作时间" min-width="140px" align="center"></el-table-column>
        <el-table-column prop="creatorName" label="操作人" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="reason" label="原因" min-width="100px" align="center"></el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination">
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'MemberRides',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data() {
    return {
      value1: [],
      // 搜索
      searchForm: {
        startDate: '',
        endDate: '',
        creatorName: '',
      },
    }
  },
  created() {
    this.config({
      module: '用户骑行记录表',
      api: '/business/backgroundRefund',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    selectDate(v) {
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      if (v) {
        this.searchForm.startDate = v[0]
        this.searchForm.endDate = v[1]
      }
      this.search()
    },
    reset() {
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      this.value1 = []
      this.$refs.searchForm.resetFields()
      this.search()
    },
  },
}
</script>
